// extracted by mini-css-extract-plugin
export var animation = "FocusAnimation-module--animation--768e6";
export var background = "FocusAnimation-module--background--813f1";
export var behavioral = "FocusAnimation-module--behavioral--84a6c";
export var binary = "FocusAnimation-module--binary--32adb";
export var demographics = "FocusAnimation-module--demographics--f8a1a";
export var dots = "FocusAnimation-module--dots--32c21";
export var system = "FocusAnimation-module--system--979bc";
export var transactional = "FocusAnimation-module--transactional--75f13";
export var unimpressedBlurry = "FocusAnimation-module--unimpressed-blurry--f0a64";
export var unimpressedClear = "FocusAnimation-module--unimpressed-clear--dc03e";